import { patient, patientRequiredColumn } from "./patient";
import { caregiver, caregiverRequiredColumn } from "./caregiver";
import { insurance } from "./insurance";

export const Column = {
  patient,
  caregiver,
  insurance,
};

export const ColumRequired = {
  patient: patientRequiredColumn,
  caregiver: caregiverRequiredColumn,
};
